module.exports = __webpack_public_path__ + "img/info-black.7adbb98d.png";